import { useEffect, useRef } from 'react';
import { useLocation } from 'wouter';
import { trackPageView } from '@/lib/analytics';
import { captureGclid } from '@/lib/gclid-tracker';
import { logPageView, startPageSession, endPageSession } from '@/lib/analytics-tracking';

export function usePageTracking() {
  const [location] = useLocation();
  const previousLocation = useRef<string>();

  useEffect(() => {
    if (!location) {
      return;
    }

    const currentPath = location;
    const previousPath = previousLocation.current;
    
    if (currentPath === previousPath) {
      return;
    }

    const origin = window.location.origin;
    const currentUrl = `${origin}${currentPath}`;
    const referrerUrl = previousPath 
      ? `${origin}${previousPath}` 
      : document.referrer || null;

    previousLocation.current = currentPath;

    // Persist ?gclid= from whatever page the ad actually landed on. Without
    // this the value only survives when someone arrives directly on /signup
    // with the parameter attached — a visitor who lands on the homepage and
    // then navigates to sign up loses their Google Ads attribution entirely.
    captureGclid();

    trackPageView(currentUrl, referrerUrl);

    if (previousPath) {
      endPageSession(previousPath).catch(() => {});
    }
    
    logPageView(currentPath, document.title, referrerUrl).catch(() => {});
    startPageSession(currentPath).catch(() => {});

    console.log('[Page Tracking] Page view tracked:', currentPath, 'referrer:', referrerUrl);
  }, [location]);
}
